module.exports = __webpack_public_path__ + "img/scene3-2.757cccdf.jpg";